import React, { Component } from 'react';

class ModalTrigger extends Component {
  render() {
     switch (this.props.type) {
        case 'denuncie':
            return (
               <button 
                  className="button button--side-nav button--denuncie" 
                  ref={this.props.buttonRef}
                  onClick={this.props.showModal}
               >
                  <span className="button__title">Compartilhe uma situação vivenciada por você</span>
                  <span className="button__subtitle">(Somente profissionais atuando na linha de frente)</span>
               </button>
            )
         case 'vivenciadas':
            return (
               <button 
                  className="button button--side-nav button--vivenciadas" 
                  ref={this.props.buttonRef}
                  onClick={this.props.showModal}
               >
                  <span className="button__title">Relate o que você viu</span>
                  <span className="button__subtitle">(Profissionais atuando na linha de frente e população em geral)</span>
               </button>
               )
         default:
     }
  }
}

export default ModalTrigger;
